<template lang='pug'>
  .quill.editor.component
    icon-button( @click.native='edit = !edit' )
      icon
    wrapper.max-960( v-if='!edit' )
      status-toggle( :article='article' )

      input.title( v-model='article.title' )
      textarea.desc( v-model='article.description' placeholder='Enter a description...' )
      vue-tags(
        v-model="tag"
        :tags="article.tags"
        @tags-changed="tags => article.tags = tags"
      )
      images( 
        ref='images'
        collection='articles' 
        :pid='article.id'
      )
  
    quill-editor(
      v-else
      :value='article.html'
      :options='options'
      @blur='blur'
      @focus='focus'
      @ready='ready'
      @change='change'
    )
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'
  import Wrapper from '@/components/containers/wrapper'
  import Images from '@/components/inputs/attachable/images'
  import VueTags from '@johmun/vue-tags-input'
  import StatusToggle from '@/components/toggles/status'
  import IconButton from '@/components/buttons/icon-only/base'
  import Icon from 'vue-material-design-icons/PlaylistEdit'

  export default {
    name: 'quill.editor.component',

    components: {
      quillEditor,
      Wrapper,
      Images,
      VueTags,
      StatusToggle,
      IconButton,
      Icon
    },

    props: {
      options: { type: Object, default: () => ({}) },
      article: { type: Object, required: true },
      html: { default: '' },
    },

    data() {
      return {
        scrolled: false,
        tag: '',
        edit: false
      }
    },

    methods: {
      blur( quill ) {
        console.log('emitting blur')
        this.$refs.images.set()
        this.$emit( 'blur' )
       // console.log('editor blur!', quill)
      //  this.update()
      },

      focus( quill ) {
       // console.log('editor focus!', quill)
      },

      ready( quill ) {
       // console.log('editor ready!', quill)
      },

      change({ quill, html, text }) {
        this.$emit( 'update:html', html )
      },
    }
  }
</script>

<style scoped lang='stylus'>
  button.base
    position fixed
    bottom 16vh
    right 1vw
    font-size 2em
    z-index 1

  input, textarea
    border 0
    font-size 1em
    width 100%
    color inherit
    display block
  
  input
    font-family Yellowtail
  
  textarea
    font-family Oswald
    min-height 6em
    resize none

  .images
    margin 32px 0

  .title
    margin 32px 0
    font-size 3.2em

  .desc
    font-family Oswald
    font-size 1.2em
    margin 32px 0
    line-height 1.6

  .quill.editor
    text-shadow var(--shadow-text)
    .vue-tags-input
      background rgba( 240 240 240 .25 )
      max-width 100%
      >>> .ti-input
        border-radius 5px
        padding .5em
      >>> .ti-tag
        background rgba( 0 0 0 .5 )
        padding .25em .5em
    .wrapper
      padding 0 4.8vw
      box-sizing border-box

  >>> .ql-toolbar
    background rgb( 216 216 216 )
    position sticky
    box-shadow 0 0 8px 0 rgba( 64 64 64 .1 )
    top 0
    width 100%
    left 0
    border 0
    border-bottom 1px solid rgb( 192 192 192 )
    border-top 1px solid rgb( 192 192 192 )
    z-index 1
    padding 8px
    transition all 320ms
    text-align center
  
  >>> .ql-snow .ql-editor
    font-size 1.24em
    margin 0 auto
    padding 4.8vh 16vw
    font-family Roboto
    line-height 1.75
    @media( max-width: 1600px )
      padding 4.8vh 12vw
    @media( max-width: 1440px )
      padding 4.8vh 8vw
    @media( max-width: 1200px )
      padding 4.8vh 4.8vw
    strong
      font-weight 400
    i, em
      font-style italic
    p
      margin 1em 0
    h1, h2
      margin 3em 0 .5em 0
    h3
      margin-top 3em
    ul, ol
      padding 0
      padding-left 1.75em
      list-style-type circle
      li
        margin 1em 0
        padding-left .25em
    a
      font-style italic
      text-decoration none
      font-weight bold
      color rgb( 0 125 150 ) !important
      cursor pointer
    .ql-syntax
      background-color rgb( 64 64 64 )
      color rgb( 224 224 224 )

  >>> .ql-container.ql-snow
    border 0
    padding 0
</style>
